export const SelectValues = {
	TimeSeriesForecasting: {
		LocalAuthorities: [
			"Wales",
			"Blaenau Gwent",
			"Bridgend",
			"Caerphilly",
			"Cardiff",
			"Carmarthenshire",
			"Ceredigion",
			"Conwy",
			"Denbighshire",
			"Flintshire",
			"Gwynedd",
			"Isle of Anglesey",
			"Merthyr Tydfil",
			"Monmouthshire",
			"Neath Port Talbot",
			"Newport",
			"Pembrokeshire",
			"Powys",
			"Rhondda Cynon Taf",
			"Swansea",
			"Torfaen",
			"Vale of Glamorgan",
			"Wrexham",
			"",
		],
		ForecastingMethods: ["Model 1", "Model 2", ""],
		Indicators: [
			"CLA per 10,000 population aged under 18",
			"CLA between 0-4 years old (% of total CLA)",
			"CLA between 5-9 years old (% of total CLA)",
			"CLA between 10-15 years old (% of total CLA)",
			"CLA in foster placement (% of total CLA)",
			"CLA placed with parents (% of total CLA)",
			"CLA in other placements (% of total CLA)",
			"",
		],
	},
	ScenarioAnalysis: {
		LocalAuthorities: [
			"Wales",
			"Blaenau Gwent ",
			"Bridgend ",
			"Caerphilly ",
			"Cardiff ",
			"Carmarthenshire ",
			"Ceredigion ",
			"Conwy ",
			"Denbighshire ",
			"Flintshire ",
			"Gwynedd ",
			"Isle of Anglesey ",
			"Merthyr Tydfil ",
			"Monmouthshire ",
			"Neath Port Talbot ",
			"Newport ",
			"Pembrokeshire ",
			"Powys ",
			"Rhondda Cynon Taf ",
			"Swansea ",
			"Torfaen ",
			"Vale of Glamorgan ",
			"Wrexham ",
			"",
		],
	},
};
